// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__JAupl","calendarButtons":"ClockData_calendarButtons__2O7U9"};